import React, { useState } from 'react';
import { Table, Button, Input, Select, Popconfirm, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSearchApi } from '../../../network/itemList';
import { getSalaryComponent } from '../../../network/salaryStructureHr';
import { getSalaryComponentHr } from '../../../network/salaryComponentHr';

const DeductionsList = ({ setDataSource, dataSource, t }) => {
  const [count, setCount] = useState(0);
  const { data: salaryComponents } = useQuery({
    queryKey: [queryKeys.getSearchApiSalaryComponents],
    queryFn: () => getSearchApi('Salary Component'),
    keepPreviousData: true,
  });
  const { data: salaryComponentsHr } = useQuery({
    queryKey: [queryKeys.getSalaryComponentHr],
    queryFn: () => getSalaryComponentHr(),
    keepPreviousData: true,
  });
  
  const columns = [
    {
      title: t.salaryComponent,
      dataIndex: 'salary_component',
      render: (text, record, index) => (
        <Select
          placeholder={t.salaryComponent}
          value={record?.salary_component}
          style={{ width: '100%' }}
          popupMatchSelectWidth={false}
          options={salaryComponentsHr?.data?.map((component) => ({
            value: component.salary_component,
            label: component.salary_component,
            option: component,
          }))}
          onChange={(value,option) => {
            console.log(option, 'option');
            
            const newDataSource = [...dataSource];
            newDataSource[index] = { 
                ...newDataSource[index], 
                salary_component: value ,
                abbr: option.option.salary_component_abbr,
                amount: option.option.amount,
                formula: option.option.formula,
                condition: option.option.condition,
                depends_on_payment_days: option.option.depends_on_payment_days,
            };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.abbr,
      dataIndex: 'abbr',
      render: (text, record, index) => (
        <Input
        placeholder={t.abbr}
        value={record?.abbr}
        style={{ width: '100%' }}
        onChange={(e) => {
          const newDataSource = [...dataSource];
          newDataSource[index] = { ...newDataSource[index], abbr: e.target.value };
          setDataSource(newDataSource);
        }}
        disabled
      />
      ),
    },
    {
      title: t.amount,
      dataIndex: 'amount', 
      render: (text, record, index) => (
        record.amount_based_on_formula === 0 && (
        <Input
          placeholder={t.amount}
          type="number"
          value={record.amount}
          style={{ width: '100%' }}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = { ...newDataSource[index], amount: e.target.value };
            setDataSource(newDataSource);
          }}
        />
        )
      ),
    },
    {
      title: t.dependsOnPaymentDays,
      dataIndex: 'depends_on_payment_days',
      render: (text, record, index) => (
        <Select
          placeholder={t.dependsOnPaymentDays}
          value={record.depends_on_payment_days}
          style={{ width: '100%' }}
          options={[
            { value: 1, label: 'Yes' },
            { value: 0, label: 'No' },
          ]}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = { ...newDataSource[index], depends_on_payment_days: value };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.doNotIncludeInTotal,
      dataIndex: 'do_not_include_in_total',
      render: (text, record, index) => (
        <Select
          placeholder={t.doNotIncludeInTotal}
          value={record.do_not_include_in_total}
          style={{ width: '100%' }}
          options={[
            { value: 1, label: 'Yes' },
            { value: 0, label: 'No' },
          ]}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = { ...newDataSource[index], do_not_include_in_total: value };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.condition,
      dataIndex: 'condition',
      render: (text, record, index) => (
        <Input
          placeholder={t.condition}
          value={record.condition}
          style={{ width: '100%' }}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = { ...newDataSource[index], condition: e.target.value };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.amountBasedOnFormula,
      dataIndex: 'amount_based_on_formula',
      render: (text, record, index) => (
        <Select
          placeholder={t.amountBasedOnFormula}
          value={record.amount_based_on_formula}
          style={{ width: '100%' }}
          options={[
            { value: 1, label: 'Yes' },
            { value: 0, label: 'No' },
          ]}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = { ...newDataSource[index], amount_based_on_formula: value };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.formula,
      dataIndex: 'formula',
      render: (text, record, index) => (
        record.amount_based_on_formula === 1 && (
        <Input
          placeholder={t.formula}
          value={record.formula}
          style={{ width: '100%' }}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = { ...newDataSource[index], formula: e.target.value };
            setDataSource(newDataSource);
          }}
        />
        )
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button type="primary" danger icon={<DeleteOutlined />} size="small" />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
    //   salary_component: '',
    //   abbr: '',
      amount: 0,
      depends_on_payment_days: 0,
      do_not_include_in_total: 0,
    //   condition: '',
      amount_based_on_formula: 0,
    //   formula: '',
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };

  return (
    <Card>
      <Table
              className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{ hideOnSinglePage: true }}
        scroll={{ x: 'max-content' }}
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default DeductionsList;
